import { server } from '../../engine/server'
import { modal } from '../../utilities/modal'

var AdminSubscriptions = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getSubscriptions: function(callback) {
		var self = this;
		var url = "admin/subscriptions";
		var data = self.server.getData(url,null,true);
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getExpectedIncome: function(callback) {
		var self = this;
		var url = "admin/subscriptions/revenue";
		var data = self.server.getData(url,null,true);
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getSubscriptionsCount: function(callback) {
		var self = this;
		var url = "admin/subscriptions/count";
		var data = self.server.getData(url,null,true);
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getSubscription: function(id, callback) {
		var self = this;
		var url = "admin/subscription/" + id;
		// #  Send to server object for processing
		var data = self.server.getData(url,null, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	updateSubscription: function(id, name, price, user_id, callback) {
		var self = this;
		var url = "admin/subscription/" + id;
		// #  Send to server object for processing
		var data = self.server.getData(url, {name: name, price: price, user_id: user_id}, true, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	saveSubscription: function(name, price, callback) {
		var self = this;
		var url = "admin/subscription";
		// #  Send to server object for processing
		var data = self.server.getData(url,{name: name, price: price}, true, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	deleteSubscription: function(id, callback) {
		modal.showDangerModalWithOK("Are you sure?","You are about to delete this subscription. All data associated will be deleted and you will not be able to recover.","Yes, Delete");
		jQuery(".move-on").on('click',function() {
			var self = this;
			var url = "admin/subscription/" + id;
			// #  Send to server object for processing
			var data = self.server.getData(url,null, true, 'DELETE');
			// #  Listen to our data
			data
			.done(function(response){
				// #  Validate response
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
					// #  Display error
					modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
				}
				if(callback) {
					callback(response);
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
			});
		});
	},
});

export let adminSubscriptions = new AdminSubscriptions();


// WEBPACK FOOTER //
// app/core/controllers/Admin/AdminSubscriptions.js